var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultSorting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4798 6.85353L7.4798 8.85353C7.67507 9.0488 7.9916 9.0488 8.18687 8.85353L10.1869 6.85353C10.3821 6.65827 10.3821 6.34173 10.1869 6.14647C9.9916 5.9512 9.67507 5.9512 9.4798 6.14647L8.33333 7.29287V0.5C8.33333 0.22386 8.10947 0 7.83333 0C7.5572 0 7.33333 0.22386 7.33333 0.5V7.29287L6.18687 6.14647C5.9916 5.9512 5.67507 5.9512 5.4798 6.14647C5.28453 6.34173 5.28453 6.65827 5.4798 6.85353ZM2.85355 0.146447C2.65829 -0.0488135 2.34171 -0.0488135 2.14645 0.146447L0.146445 2.14645C-0.048815 2.34171 -0.048815 2.65829 0.146445 2.85355C0.341705 3.04881 0.658292 3.04881 0.853552 2.85355L2 1.70711V8.5C2 8.77613 2.22386 9 2.5 9C2.77614 9 3 8.77613 3 8.5V1.70711L4.14647 2.85355C4.34173 3.04881 4.65827 3.04881 4.85353 2.85355C5.0488 2.65829 5.0488 2.34171 4.85353 2.14645L2.85355 0.146447Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultSorting);
export default __webpack_public_path__ + "static/media/defaultSorting.9e41b745c8506054f315301a0792be78.svg";
export { ForwardRef as ReactComponent };